/* libs */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";
import axios from "axios";
import moment from "moment";

import { SimpleSelectInput, CollectionAccordion } from "./index";
import validatehoc from "../Validator";
import GetItem from "../../../helpers/dataProviders/getItem";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

class BrushfireSessionMapper extends Component {
	constructor(props) {
		super(props);
		this.state = {
			minimizePlaceholder: false,
			eventData: [],
			eventOptions: [],
			expandedFieldIndex: [],
			fieldData: {},
			fieldOptions: {},
			attendeeTypeData: {},
			sessionOptions: [],
			isLoading: false,
			showAdvanced: false,
			brushfireApiKey: null,
			brushfireAccessKey: null,
		};
		this.appKey = parseAppKey();
	}

	componentDidMount() {
		if (
			this.props.formValues &&
			(this.props.formValues.brushfireApiKey || this.props.formValues.brushfireAccessKey)
		) {
			this.setState(
				{
					brushfireApiKey: this.props.formValues.brushfireApiKey,
					brushfireAccessKey: this.props.formValues.brushfireAccessKey,
				},
				() => {
					this.getBrushfireEvents(true);
				}
			);
		} else {
			this.getBrushfireEvents(true);
		}
		this.getSessions();
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.formValues &&
			(prevProps.formValues.brushfireApiKey !== this.props.formValues.brushfireApiKey ||
				prevProps.formValues.brushfireAccessKey !== this.props.formValues.brushfireAccessKey)
		) {
			this.setState(
				{
					brushfireApiKey: this.props.formValues.brushfireApiKey,
					brushfireAccessKey: this.props.formValues.brushfireAccessKey,
				},
				() => {
					this.getBrushfireEvents();
				}
			);
		}
	}

	generateBrushfireClient = () => {
		let brushfireApiKey = this.state.brushfireApiKey;
		if (brushfireApiKey && brushfireApiKey.match(/^[a-zA-Z0-9]{16}$/)) {
			const authHash = btoa(`${brushfireApiKey}:`);
			return axios.create({
				baseURL: "https://api.brushfire.com/",
				//timeout: 10000,
				headers: {
					Authorization: `Basic ${authHash}`,
					Accept: "application/json",
					"Content-Type": "application/json",
					"api-version": "2019-01-17",
				},
			});
		}
		return null;
	};

	getSessions = () => {
		GetItem(`/apps/${this.appKey}/sessions`).then(data => {
			let values = [];
			data.data.forEach(item => {
				values.push({
					value: item.id,
					key: item.id,
					label: `${item.title} (${moment(item.startsAt).format("MMMM Do YYYY, h:mm:ss a")})`,
				});
			});
			this.setState({ sessionOptions: values });
		});
	};

	getBrushfireEvents = (buildFields = false) => {
		let bfClient = this.generateBrushfireClient();
		if (bfClient) {
			bfClient
				.get("/events")
				.then(data => {
					let eventData = data.data;
					let eventOptions = [];
					eventData.forEach(event => {
						eventOptions.push({ key: event.EventNumber, value: event.EventNumber, label: event.Title });
					});
					this.setState({ eventData, eventOptions }, () => {
						if (buildFields) {
							let value = this.props.fieldApi.getValue();
							value.forEach(event => {
								this.getBrushfireFieldsForEvent(event.eventNumber);
							});
						}
					});
				})
				.catch(error => {});
		}
	};

	addEvent = e => {
		e.preventDefault();
		e.stopPropagation();
		const { fieldApi } = this.props;
		let value = fieldApi.getValue();
		let newValue;
		if (value) {
			newValue = value.concat();
		} else {
			newValue = [];
		}
		newValue.push({ eventNumber: "", eventTitle: "", sessions: [] });
		fieldApi.setValue(newValue);
		fieldApi.setTouched(true);
		this.setState({ expandedIndex: newValue.length - 1 });
	};

	addSession = (e, i) => {
		e.preventDefault();
		e.stopPropagation();
		const { fieldApi } = this.props;
		let value = fieldApi.getValue();
		let newValue = value.concat();

		newValue[i].sessions.push({ sessionId: "", attendeeTypes: [], optionIds: {} });
		fieldApi.setValue(newValue);
		fieldApi.setTouched(true);
	};

	changeEvent = (e, i) => {
		let value = e.target.value;
		let { fieldApi } = this.props;
		const { eventData } = this.state;
		const event = eventData.find(evt => evt.EventNumber.toString() === value);
		if (event) {
			let fieldValue = fieldApi.getValue().concat();
			fieldValue[i] = { eventNumber: value, eventTitle: event.Title, sessions: [] };
			fieldApi.setValue(fieldValue);
			fieldApi.setTouched(true);
			this.getBrushfireFieldsForEvent(value);
		}
	};

	changeFieldValue = (e, i, fieldIndex, propertyName) => {
		let value = e.target.value;
		let { fieldApi } = this.props;
		let fieldValue = fieldApi.getValue().concat();
		fieldValue[i].sessions[fieldIndex][propertyName] = value;
		fieldApi.setValue(fieldValue);
		fieldApi.setTouched(true);
	};

	toggleData = (i, currentState, value, sessionIndex, propertyName) => {
		let { fieldApi } = this.props;
		let fieldValue = fieldApi.getValue().concat();
		if (currentState) {
			var index = fieldValue[i].sessions[sessionIndex][propertyName].indexOf(value);
			if (index !== -1) fieldValue[i].sessions[sessionIndex][propertyName].splice(index, 1);
		} else {
			fieldValue[i].sessions[sessionIndex][propertyName].push(value);
		}
		fieldApi.setValue(fieldValue);
		fieldApi.setTouched(true);
	};

	toggleOptionData = (i, currentState, value, sessionIndex, propertyName, fieldIndex) => {
		let { fieldApi } = this.props;
		let fieldValue = fieldApi.getValue().concat();
		if (currentState) {
			var index = fieldValue[i].sessions[sessionIndex][propertyName][fieldIndex].indexOf(value);
			if (index !== -1) {
				fieldValue[i].sessions[sessionIndex][propertyName][fieldIndex].splice(index, 1);
				if (fieldValue[i].sessions[sessionIndex][propertyName][fieldIndex].length === 0) {
					var indexToRemove = fieldValue[i].sessions[sessionIndex][propertyName].indexOf(fieldIndex);
					if (indexToRemove !== -1) {
						fieldValue[i].sessions[sessionIndex][propertyName].splice(indexToRemove, 1);
					}
				}
			}
		} else {
			if (!fieldValue[i].sessions[sessionIndex][propertyName][fieldIndex]) {
				fieldValue[i].sessions[sessionIndex][propertyName][fieldIndex] = [];
			}
			fieldValue[i].sessions[sessionIndex][propertyName][fieldIndex].push(value);
		}
		fieldApi.setValue(fieldValue);
		fieldApi.setTouched(true);
	};

	moveFieldUp = (eventIndex, fieldIndex) => {
		const { fieldApi } = this.props;
		let fieldValue = fieldApi.getValue().concat();
		if (fieldIndex > 0) {
			let before = Object.assign({}, fieldValue[eventIndex].sessions[fieldIndex - 1]);
			let after = Object.assign({}, fieldValue[eventIndex].sessions[fieldIndex]);
			fieldValue[eventIndex].sessions[fieldIndex - 1] = after;
			fieldValue[eventIndex].sessions[fieldIndex] = before;
			fieldApi.setValue(fieldValue);
			fieldApi.setTouched(true);
		}
	};

	moveFieldDown = (eventIndex, fieldIndex) => {
		const { fieldApi } = this.props;
		let fieldValue = fieldApi.getValue().concat();
		if (fieldIndex < fieldValue[eventIndex].fields.length - 1) {
			let before = Object.assign({}, fieldValue[eventIndex].sessions[fieldIndex]);
			let after = Object.assign({}, fieldValue[eventIndex].sessions[fieldIndex + 1]);
			fieldValue[eventIndex].sessions[fieldIndex] = after;
			fieldValue[eventIndex].sessions[fieldIndex + 1] = before;
			fieldApi.setValue(fieldValue);
			fieldApi.setTouched(true);
		}
	};

	deleteFieldCollection = (eventIndex, fieldIndex) => {
		const { fieldApi } = this.props;
		let newValue = fieldApi.getValue().concat();
		newValue[eventIndex].sessions.splice(fieldIndex, 1);
		fieldApi.setValue(newValue);
		fieldApi.setTouched(true);
	};

	getBrushfireFieldsForEvent = eventNumber => {
		let bfClient = this.generateBrushfireClient();
		if (bfClient) {
			bfClient
				.get(`/events/${eventNumber}/fields?fieldType=Attendees&accessKey=${this.state.brushfireAccessKey}`)
				.then(data => {
					let fieldData = Object.assign({}, this.state.fieldData);
					fieldData[eventNumber] = data.data;
					//get attendeeTypes
					bfClient
						.get(`/events/${eventNumber}/types?accessKey=${this.state.brushfireAccessKey}`)
						.then(typeData => {
							let attendeeTypeData = Object.assign({}, this.state.attendeeTypeData);
							attendeeTypeData[eventNumber] = typeData.data;
							this.setState({ fieldData, attendeeTypeData });
						})
						.catch(error => {});
				})
				.catch(error => {});
		}
	};

	deleteCollection = index => {
		const { fieldApi } = this.props;
		let newValue = fieldApi.getValue().concat();
		newValue.splice(index, 1);
		fieldApi.setValue(newValue);
		fieldApi.setTouched(true);
	};

	render() {
		const { fieldState, placeholder, isRequired } = this.props;
		const { value } = fieldState;
		const { eventOptions, brushfireApiKey, fieldData, sessionOptions, attendeeTypeData } = this.state;
		return (
			<Fragment>
				{brushfireApiKey ? (
					<div>
						<div>
							<div className="btn-circle m-right" title="Add An Event" onClick={e => this.addEvent(e)}>
								<i className="fal fa-plus icon"></i>
							</div>
							<h4 className="collection-title">{placeholder}</h4>
						</div>
						<div className="collection-group">
							{value &&
								value.length > 0 &&
								value.map((event, i) => {
									let title = isRequired ? "* " : "";
									title += event.eventTitle ? event.eventTitle : "Pick an Event";
									return (
										<CollectionAccordion
											key={i}
											title={title}
											expanded={this.state.expandedIndex === i}
											index={i}
											toggleCollectionItem={expandedIndex => this.setState({ expandedIndex })}
											deleteCollection={this.deleteCollection}
											totalCount={value.length}
										>
											<div className="collection-item-properties">
												{eventOptions && (
													<div>
														<SimpleSelectInput
															id="eventNumber"
															placeholder="Event"
															values={eventOptions}
															value={event.eventNumber}
															onChange={e => {
																this.changeEvent(e, i);
															}}
														/>
													</div>
												)}
												{fieldData[event.eventNumber] && (
													<div>
														<div>
															<div
																className="btn-circle m-right"
																title="Connect A Session"
																onClick={e => this.addSession(e, i)}
															>
																<i className="fal fa-plus icon"></i>
															</div>
															<h4 className="collection-title">Sessions</h4>
														</div>
														<div className="collection-group">
															{event.sessions.map((session, sessionIndex) => {
																let sessionOption = session.sessionId
																	? sessionOptions.find(
																			ses =>
																				ses.value.toString() ===
																				session.sessionId.toString()
																	  )
																	: null;
																return (
																	<div key={sessionIndex}>
																		<CollectionAccordion
																			title={
																				sessionOption
																					? sessionOption.label
																					: "Pick a Session"
																			}
																			expanded={
																				this.state.expandedFieldIndex[i] ===
																				sessionIndex
																			}
																			index={sessionIndex}
																			toggleCollectionItem={expandedIndex => {
																				let newValue = this.state.expandedFieldIndex.concat();
																				newValue[i] =
																					newValue[i] === expandedIndex
																						? null
																						: expandedIndex;
																				this.setState({
																					expandedFieldIndex: newValue,
																				});
																			}}
																			moveUp={fieldIndex => {
																				this.moveFieldUp(i, fieldIndex);
																			}}
																			moveDown={fieldIndex => {
																				this.moveFieldDown(i, fieldIndex);
																			}}
																			deleteCollection={fieldIndex => {
																				this.deleteFieldCollection(
																					i,
																					fieldIndex
																				);
																			}}
																			totalCount={event.sessions.length}
																		>
																			{sessionOptions && (
																				<div>
																					<SimpleSelectInput
																						value={session.sessionId}
																						field="sessionId"
																						id="sessionId"
																						placeholder="Pick a Session"
																						values={sessionOptions}
																						isRequired
																						onChange={e =>
																							this.changeFieldValue(
																								e,
																								i,
																								sessionIndex,
																								"sessionId"
																							)
																						}
																					/>
																					{attendeeTypeData[
																						event.eventNumber
																					] && (
																						<div>
																							<h3 className="ta-center">
																								Attendee Types
																							</h3>
																							{
																								//TODO add help text that explains that the session maps to any selected attendee types that match the user AND all selected field options which the user picked
																							}
																							{attendeeTypeData[
																								event.eventNumber
																							].map(attendeeType => {
																								let active = session.attendeeTypes.includes(
																									attendeeType.Id
																								);
																								return (
																									<div
																										key={
																											attendeeType.Id
																										}
																										className={`on-off-item ${
																											active
																												? "on"
																												: "off"
																										}`}
																										onClick={() =>
																											this.toggleData(
																												i,
																												active,
																												attendeeType.Id,
																												sessionIndex,
																												"attendeeTypes"
																											)
																										}
																									>
																										<div className="on-off-switch"></div>
																										{
																											attendeeType.Name
																										}
																									</div>
																								);
																							})}
																						</div>
																					)}
																					{fieldData[event.eventNumber] && (
																						<div>
																							<h3 className="ta-center">
																								Field Options
																							</h3>
																							{fieldData[
																								event.eventNumber
																							].map(fieldItem => {
																								let jsx = [];
																								if (
																									fieldItem.Options &&
																									fieldItem.Options
																										.length
																								) {
																									jsx.push(
																										<div className="field-group">
																											<h4>
																												{
																													fieldItem.Label
																												}
																											</h4>
																										</div>
																									);
																									fieldItem.Options.forEach(
																										fieldOption => {
																											let active =
																												session
																													.optionIds[
																													fieldItem
																														.Id
																												] &&
																												session.optionIds[
																													fieldItem
																														.Id
																												].includes(
																													fieldOption.Id
																												);
																											jsx.push(
																												<div
																													key={
																														fieldOption.Id
																													}
																													className={`on-off-item ${
																														active
																															? "on"
																															: "off"
																													}`}
																													onClick={() =>
																														this.toggleOptionData(
																															i,
																															active,
																															fieldOption.Id,
																															sessionIndex,
																															"optionIds",
																															fieldItem.Id
																														)
																													}
																												>
																													<div className="on-off-switch"></div>
																													{
																														fieldOption.Label
																													}
																												</div>
																											);
																										}
																									);
																									return jsx;
																								} else {
																									return null;
																								}
																							})}
																						</div>
																					)}
																				</div>
																			)}
																		</CollectionAccordion>
																	</div>
																);
															})}
														</div>
													</div>
												)}
											</div>
										</CollectionAccordion>
									);
								})}
						</div>
					</div>
				) : (
					<div className="alert alert-warning">First, Add Your Brushfire Api Key</div>
				)}
			</Fragment>
		);
	}
}

BrushfireSessionMapper.propTypes = {
	propertyKey: PropTypes.string,
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	values: PropTypes.array,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	defaultEnabled: PropTypes.bool,
	fieldState: PropTypes.object,
	appKey: PropTypes.string,
	fieldApi: PropTypes.object,
	formApi: PropTypes.object,
	formValues: PropTypes.object,
};

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <BrushfireSessionMapper fieldState={fieldState} {...props} />),
	"array"
);

export default Wrapper;
